export function maskCpfAndCnpj(document: string): string {

    if (!document) {
        return '';
    }

    const normalizedDocument = document.toUpperCase().replace(/[^A-Z0-9]/g, '');
    const cleaned = normalizedDocument.replace(/\D/g, '');
    const totalLength = normalizedDocument.length;

    // Se há dígitos suficientes, aplica máscara com os dígitos
    if (cleaned.length === 11) {
        return cleaned.replace(/(\d{3})(\d{3})(\d{3})(\d{2})/, '$1.$2.$3-$4');
    } else if (cleaned.length === 14) {
        return cleaned.replace(/(\d{2})(\d{3})(\d{3})(\d{4})(\d{2})/, '$1.$2.$3/$4-$5');
    } else if (normalizedDocument.length === 14) {
        return normalizedDocument.replace(/([A-Z0-9]{2})([A-Z0-9]{3})([A-Z0-9]{3})([A-Z0-9]{4})(\d{2})/, '$1.$2.$3/$4-$5');
    }
    
    // Se não há dígitos suficientes, aplica máscara visualmente no valor original
    if (cleaned.length < 11) {
        if (totalLength === 14) {
            // Aplica máscara CNPJ visualmente: 00.000.000/0000-00
            return normalizedDocument.substring(0, 2) + '.' + 
                   normalizedDocument.substring(2, 5) + '.' + 
                   normalizedDocument.substring(5, 8) + '/' + 
                   normalizedDocument.substring(8, 12) + '-' + 
                   normalizedDocument.substring(12, 14);
        } else if (totalLength === 11) {
            // Aplica máscara CPF visualmente: 000.000.000-00
            return normalizedDocument.substring(0, 3) + '.' + 
                   normalizedDocument.substring(3, 6) + '.' + 
                   normalizedDocument.substring(6, 9) + '-' + 
                   normalizedDocument.substring(9, 11);
        }
    }

    return normalizedDocument;

}

export function getDocumentLabel(document: string): string {

    if (!document) {
        return '';
    }

    const cleaned = document.replace(/\D/g, '');
    
    // Se não houver dígitos suficientes, tenta pelo comprimento total
    if (cleaned.length < 11) {
        const totalLength = document.replace(/\s/g, '').length;
        
        if (totalLength === 14) {
            return 'CNPJ';
        } else if (totalLength === 11) {
            return 'CPF';
        }
        return 'CPF/CNPJ';
    }

    if (cleaned.length === 11) {
        return 'CPF';
    } else if (cleaned.length === 14) {
        return 'CNPJ';
    }

    return 'CPF/CNPJ';

}

export function maskPhoneNumber(phone: string): string {

    if (!phone) {
        return '';
    }

    const cleaned = phone.replace(/\D/g, '');

    if (cleaned.length === 10) {

        return cleaned.replace(/(\d{2})(\d{4})(\d{4})/, '($1) $2-$3');
    } else if (cleaned.length === 11) {

        return cleaned.replace(/(\d{2})(\d{5})(\d{4})/, '($1) $2-$3');
    } else {

        return phone;
    }

}

export function maskZipCode(zipCode: string): string {

    if (!zipCode) {
        return '';
    }

    const cleaned = zipCode.replace(/\D/g, '');

    if (cleaned.length === 8) {

        return cleaned.replace(/(\d{5})(\d{3})/, '$1-$2');
    } else {

        return zipCode;
    }

}

export function maskOdometer(value: number | string | null | undefined): string {

    if (value === null || value === undefined) {
        return '';
    }

    const digitsOnly = String(value).replace(/\D/g, '');

    if (!digitsOnly) {
        return String(value);
    }

    const normalizedDigits = digitsOnly.replace(/^0+(?=\d)/, '');
    return normalizedDigits.replace(/\B(?=(\d{3})+(?!\d))/g, '.');

}

/**
 * Remove formatting from CPF/CNPJ document.
 * Returns only digits.
 */
export function unmaskCpfAndCnpj(document: string): string {
    if (!document) {
        return '';
    }
    return document.replace(/\D/g, '');
}

/**
 * Remove formatting from phone number.
 * Returns only digits.
 */
export function unmaskPhoneNumber(phone: string): string {
    if (!phone) {
        return '';
    }
    return phone.replace(/\D/g, '');
}

/**
 * Remove formatting from ZIP code.
 * Returns only digits.
 */
export function unmaskZipCode(zipCode: string): string {
    if (!zipCode) {
        return '';
    }
    return zipCode.replace(/\D/g, '');
}